import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Yoga from "./pages/Yoga";
import Dance from "./pages/Dance";
import Hit from "./pages/Hit";
import GroupClasses from "./pages/GroupClasses";
import Fitness from "./pages/Fitness";
import Performance from "./pages/Performance";
import System from "./pages/System";
import ApplyPerformanceLeadership from "./pages/ApplyPerformanceLeadership";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import RefundPolicy from "./pages/RefundPolicy";
import ClarityCall from "./pages/ClarityCall";

function App() {
  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/yoga" element={<Yoga />} />
        <Route path="/dance" element={<Dance />} />
        <Route path="/hit" element={<Hit />} />
        <Route path="/group-classes" element={<GroupClasses />} />
        <Route path="/fitness" element={<Fitness />} />
        <Route path="/performance" element={<Performance />} />
        <Route path="/system" element={<System />} />
        <Route
          path="/apply-performance-leadership"
          element={<ApplyPerformanceLeadership />}
        />
         <Route
          path="/clarity-call"
          element={<ClarityCall />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </>
  );
}

export default App;
